module.exports = __webpack_public_path__ + "images/7dac0c67.png";